import React, { ChangeEventHandler, FormEventHandler, useState } from 'react'
import { ReactFC } from 'common/types/ReactFC'
import { konnectStrings } from 'common/strings/konnect-strings'
import InputGroup from 'components/forms/InputGroup'
import PhoneInput from 'components/forms/PhoneInput'
import ReactSelect from 'react-select'
import { TeamSizeData } from 'common/TeamSizeData'
import Button from 'components/forms/Button'
import * as yup from 'yup'
import { isValidNumber } from 'libphonenumber-js'
import { useFormik } from 'formik'
import { KonnectFormValuesType } from 'common/types/konnect-form-types'
import { preventDefault } from 'common/utils/preventDefault'
import { selectStyles } from 'components/select-styles'
import imageResize from 'project/image-proxy-web'
import HeadingWithSpan from 'components/HeadingWithSpan'
import dataRelay from 'data-relay'
import { marketplaceStrings } from 'common/strings/marketplace-strings'
import { Project } from 'common/project'
import EmbededKonnectForm from './EmbededKonnectForm'
type KonnectFormType = {}

export const konnectFormSchema = {
  company_name: yup.string().required('Required'),
  email: yup
    .string()
    .email('Please provide a valid email address')
    .required('Required'),
  name: yup.string().required('Required'),
  notes: yup.string().nullable(),
  phone_number: yup
    .string()
    .required('Required')
    .test('test-name', 'Validation failure message', function (value) {
      const { createError, path } = this
      if (value && isValidNumber(value)) {
        return true
      }
      return createError({ message: 'Invalid', path })
    }),
  team_size: yup.string().required('Required'),
}
const schema = yup.object().shape(konnectFormSchema)

export const konnectFormInitialValues: KonnectFormValuesType = {
  company_name: '',
  email: '',
  name: '',
  notes: '',
  phone_number: '',
  team_size: '',
}

const KonnectForm: ReactFC<KonnectFormType> = ({}) => {
  return <EmbededKonnectForm />
}

export default KonnectForm
